// DeepResearchPage.js
import React, { useEffect } from "react";
import DeepResearchGate from "../../../DeepResearchGate";

export default function DeepResearchPage() {
    useEffect(() => {
        document.body.classList.add("page-deep-research");
        return () => document.body.classList.remove("page-deep-research");
    }, []);

    return (
        <div className="deep-research-page">
            <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}>
                <DeepResearchGate
                    token={localStorage.getItem("access_token")}
                    height="100%"
                />
            </div>
        </div>
    );
}
